
// 这个组件用于table中，启用和未启用的显示
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class EnableFlag extends Vue {
  @Prop({ type: Boolean, default: false }) enable;
}
